<template>
    <!--
       latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
       BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
   -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <div class="c-jhs-free-lp c-jhs-free-lp-animation_button js-animation-button">
            <!--中3も対象に追加！-->
            <h2 class="is-full-width">
                <img
                    class="c-jhs-free-lp-top-img"
                    :src="buildImgUrl('top_2024.png')"
                    alt="中学生限定 プリ画無料で全部もらえる！ 最大約3年間無料"
                >
            </h2>
            <div class="c-jhs-free-lp-section is-background-blue is-pdt24 is-pdx16">
                <div class="c-jhs-free-lp-section-frame">
                    <!--無料サービスのここがすごい！-->
                    <div>
                        <img
                            class="c-jhs-free-lp-section-feature-title"
                            :src="buildImgUrl('service_appeal_title_2024.png')"
                            alt="無料サービスのここがすごい！"
                        >
                    </div>
                    <!--プリ画が全部もらえる！-->
                    <div class="c-img-menu03 c-jhs-free-lp-animation js-animation">
                        <img
                            class="c-jhs-free-lp-section-feature-img01"
                            :src="buildImgUrl('service_appeal_01_2024.png')"
                            alt="プリ画が全部もらえる！ らくがきありプリもらくがきなしプリも全部もらえる！"
                        >
                    </div>
                    <!--点線-->
                    <div class="c-dotted-line-position">
                        <img :src="buildImgUrl('service_appeal_line.png')"
                             alt="点線">
                    </div>
                    <!--中1〜中3までずーっと無料でもらい放題！-->
                    <div class="c-jhs-free-lp-animation js-animation">
                        <img :src="buildImgUrl('service_appeal_02_2024.png')"
                             alt="中1〜中3までずーっと無料でもらい放題！ 最長で中1の4月〜中3の2月末までプリ画が無料でもらえる！">
                    </div>
                    <!--点線-->
                    <div class="c-dotted-line-position">
                        <img :src="buildImgUrl('service_appeal_line.png')"
                             alt="点線">
                    </div>
                    <!--無料期間が終わった後も課金はされないよ！-->
                    <div class="c-jhs-free-lp-animation js-animation">
                        <img :src="buildImgUrl('service_appeal_03_2024.png')"
                             alt="無料期間が終わった後も課金はされないよ！ 無料サービス期間が終わったら無料会員になるよ 自動で課金はされないから安心！">
                    </div>
                </div>
            </div>
            <!--誰が申し込めるの？-->
            <div class="c-jhs-free-lp-section is-background-blue">
                <div class="c-jhs-free-lp-animation js-animation">
                    <img :src="buildImgUrl('can_apply_user_2026.png')"
                         alt="誰が申し込めるの？ 申し込みの時に無料会員登録もできるよ！"
                         data-jest="after-20260401-can-apply">
                </div>
            </div>
            <!--申し込みに必要なもの-->
            <div class="c-jhs-free-lp-section is-background-pink is-pdt24 is-pdb24 is-pdx16">
                <div class="c-jhs-free-lp-section-frame c-jhs-free-lp-section-frame--sm">
                    <h3 class="c-jhs-free-lp-animation js-animation">
                        <div class="c-jhs-free-lp-requires-item">
                            <img :src="buildImgUrl('requires_school_issued_item_2026.png')"
                                 alt="申し込みに必要なもの 中学生であることが証明できる書類 年齢を確認する審査に使用します。">
                        </div>
                    </h3>
                </div>
                <div class="c-jhs-free-lp-animation js-animation is-mgt8">
                    <img :src="buildImgUrl('certificate_privacy_notice.png')"
                         alt="本人確認書類記載の情報は本サービスの年齢確認にのみ利用し、それ以外の目的で利用されることは絶対にありません。撮影画像は年齢確認完了後、当社プライバシーポリシーに定める期間内に責任をもって削除します。">
                </div>
            </div>
            <!--無料の期間はいつまで？-->
            <div class="c-jhs-free-lp-section is-background-pink">
                <div class="c-jhs-free-lp-animation js-animation c-jhs-free-lp-section-content">
                    <img :src="buildImgUrl('announce_period_2026.png')"
                         alt="無料の期間はいつまで？あなたが中3の2月末まで いつから使えるの？ 審査が承認されたらすぐに使えるよ！ 審査結果の確認方法 メールで確認またはピクトリンクで確認 ※通常1時間いないに審査結果が出ますがやむを得ない事情で5日以上かかる場合もございます"
                         data-jest="after-20260401-announce-period">
                    <div class="c-jhs-free-lp-confirm-qualification-help l-element l-flex is-center">
                        <p class="m-text-normal is-light is-mgb24">詳しい確認方法は
                            <link-text class="is-primary" :link="help1852Url" :new-window="true" text="こちら"
                                       data-jest="jhsfree-help-confirm-qualification-link"/>
                        </p>
                    </div>
                </div>
            </div>
            <!--利用中のみんなの声-->
            <div class="c-jhs-free-lp-section is-background-pink is-pdx16 is-pdt16 is-pdb8">
                <div class="c-jhs-free-lp-section is-pdx16 is-pdt16 is-pdb8">
                    <div class="c-jhs-free-lp-animation js-animation">
                        <img :src="buildImgUrl('voice_user_2024.png')"
                             alt="利用中のみんなの声">
                    </div>
                </div>
                <!--よくある質問-->
                <div class="c-jhs-free-lp-section is-pdx16 is-pdt24 is-pdb24">
                    <div class="c-jhs-free-lp-faq">
                        <h3 class="c-jhs-free-lp-animation js-animation">
                            <img :src="buildImgUrl('faq_title.png')" alt="よくある質問">
                        </h3>
                        <div class="c-jhs-free-lp-faq-list">
                            <div class="c-jhs-free-lp-faq-item">
                                <details id="faq1"
                                         class="c-jhs-free-lp-faq-accordion c-jhs-free-lp-animation js-animation">
                                    <summary class="c-jhs-free-lp-faq-title">
                                        <img :src="buildImgUrl('faq_01.png')" alt="個人情報管理は大丈夫？">
                                    </summary>
                                    <div class="c-jhs-free-lp-faq-content">
                                        <list-text :comments="true" :none="true" class="is-mgb8">
                                            <li class="m-list-text-item is-light">
                                                ・本人確認書類は年齢・不正確認業務完了後に削除されます。
                                            </li>
                                            <li class="m-list-text-item is-light">
                                                ・個人情報はフリューで適切に管理し漏洩しません。
                                            </li>
                                            <li class="m-list-text-item is-light">
                                                ・学校にフリューから連絡することはありません。
                                            </li>
                                        </list-text>
                                        <p class="m-text-comments is-light">もっと詳しく知りたい方は
                                            <link-text class="is-primary" :link="help1889Url" :new-window="true"
                                                       text="こちら" data-jest="jhsfree-help-link"/>
                                        </p>
                                    </div>
                                </details>
                            </div>
                            <div class="c-jhs-free-lp-faq-item">
                                <details id="faq2"
                                         class="c-jhs-free-lp-faq-accordion c-jhs-free-lp-animation js-animation">
                                    <summary class="c-jhs-free-lp-faq-title">
                                        <img :src="buildImgUrl('faq_02.png')" alt="本当にお金はかからないの？">
                                    </summary>
                                    <div class="c-jhs-free-lp-faq-content">
                                        <list-text :comments="true" :none="true" class="is-mgb8">
                                            <li class="m-list-text-item is-light">
                                                ・自動で課金することは絶対にありません。
                                            </li>
                                            <li class="m-list-text-item is-light">・無料サービス期間終了後は自動で無料会員になります。
                                            </li>
                                        </list-text>
                                        <p class="m-text-comments is-light">
                                            ※現在ご自身でプレミアム会員登録されている方は課金を解約することをお勧めします。
                                        </p>
                                    </div>
                                </details>
                            </div>
                            <div class="c-jhs-free-lp-faq-item">
                                <details id="faq3"
                                         class="c-jhs-free-lp-faq-accordion c-jhs-free-lp-animation js-animation">
                                    <summary class="c-jhs-free-lp-faq-title">
                                        <img :src="buildImgUrl('faq_03.png')" alt="なぜ審査があるの？">
                                    </summary>
                                    <div class="c-jhs-free-lp-faq-content">
                                        <list-text :comments="true" :none="true">
                                            <li class="m-list-text-item is-light">・不正防止のため審査を行います。</li>
                                        </list-text>
                                    </div>
                                </details>
                            </div>
                            <div class="c-jhs-free-lp-faq-item">
                                <p><img :src="buildImgUrl('faq_announce.png')"
                                        alt="不安がある方へ 不安な方は保護者の方に申し込みをお願いしてみてね。"></p>
                            </div>
                        </div>
                        <list-text class="l-element is-pdt0" :none="true" style="padding-left: 1.5em">
                            <li class="m-list-text-item is-light">その他不明点は
                                <link-text class="is-primary" :link="helpTopUrl" :new-window="true" text="こちら"
                                           data-jest="help-link"/>
                            </li>
                        </list-text>
                    </div>
                </div>
            </div>
            <!--昨年から無料サービスを利用中の方へ-->
            <h3 class="c-jhs-free-lp-section">
                <span class="c-jhs-free-lp-animation js-animation">
                    <img :src="buildImgUrl('announce_already_user_2026.png')"
                         alt="昨年から無料サービスを利用中の方へ　自動的に無料期間が延長されているよ！　2026年度も無料で使ってね！"
                         data-jest="after-20260401-already-user">
                </span>
            </h3>
            <!--サービス詳細と注意事項-->
            <jhs-free-lp-accordion/>
            <!--フロートボタン-->
            <div class="l-element button is-pdb0" :class="isScrollFull ? 'is-none' : ''">
                <jhs-free-lp-btn-float-bottom
                    :is-active="isApplyButtonActive"
                    @clicked="disableApplyButton"
                    data-jest="lp-btn-float-bottom"
                />
            </div>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import LinkText from "../../atoms/LinkText.vue";
import ListText from "../../atoms/ListText.vue";
import JhsFreeLpAccordion from "../../organisms/JhsFreeLpAccordion.vue";
import JhsFreeLpBtnFloatBottom from "../../molecules/JhsFreeLpBtnFloatBottom.vue";
import * as urlUtil from "../../../util/UrlUtil"
import {getScrollEvent} from "../../../util/Ga4EventUtil.js";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import {mapGetters} from "vuex";

/**
 * 2026年度中学生申し込みLP
 * 中学生申込LPのデザインは毎年変わることが予想されるため、共通化はせず切替は[JhsFreeLpRouter.vue] で行う
 */
export default {
    name: "JhsFreeLp2026",
    components: {
        BaseLayout,
        LinkText,
        ListText,
        JhsFreeLpAccordion,
        JhsFreeLpBtnFloatBottom,
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            isScrollFull: null,
            helpTopUrl: urlUtil.helpUrlUtil.helpTopUrl("pictlink_web"),
            help1889Url: urlUtil.helpUrlUtil.helpDetailUrl("1889"),
            help1852Url: urlUtil.helpUrlUtil.helpDetailUrl("1852"),
            isApplyButtonActive: true,
        }
    },
    computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus',
        }),
    },
    mounted() {
        getScrollEvent();
        /**
         * アニメーション
         * @type {{root: null, rootMargin: string, threshold: number}}
         */
        const options = {
            root: null,
            rootMargin: "0px 0px -50px",
            threshold: 0
        }
        const buttonOptions = {
            root: null,
            rootMargin: "0px 0px 0px",
            threshold: 0
        }
        // DOMを取得し各要素をonIntersectに渡す
        const images = document.querySelectorAll('.js-animation')
        images.forEach((target) => this.onIntersect(target, options))
        const button = document.querySelectorAll('.js-animation-button')
        button.forEach((target) => this.onIntersect(target, buttonOptions))
        /**
         * スクロール
         */
        window.addEventListener('scroll', this.onScroll, {
            capture: true
        })

        this.$router.beforeResolve((to, from, next) => {
            this.enableApplyButton()
            next()
        })
    },
    methods: {
        /**
         * アニメーション
         * @param target
         * @param options
         */
        onIntersect(target, options = {}) {
            const observer = new IntersectionObserver(this.addShowClass, options)
            // 監視したい要素をobserveする。
            observer.observe(target)
        },
        addShowClass(entries) {
            for (const e of entries) {
                // isInterseting判定で要素が交差したらclassを付与する
                if (e.isIntersecting) {
                    e.target.classList.add("show-section")
                    e.target.classList.add("show-button")
                }
            }
        },
        /**
         * スクロール
         */
        onScroll() {
            const allHeight = Math.max(
                document.body.scrollHeight, document.documentElement.scrollHeight,
                document.body.offsetHeight, document.documentElement.offsetHeight,
                document.body.clientHeight, document.documentElement.clientHeight
            );
            const mostBottom = allHeight - window.innerHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            // ブラウザによってスクロール値の反応が変わるようなので
            // 最下部ではなく下から100pxあたりでボタン非表示にするよう微調整している
            this.isScrollFull = (scrollTop + 100) >= mostBottom;
        },
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/lp/' + imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        enableApplyButton() {
            this.isApplyButtonActive = true
        },
        disableApplyButton() {
            this.isApplyButtonActive = false
        },
    },
    head: {
        link: [
            {rel: "canonical", href: location.origin + location.pathname + location.hash}
        ]
    }
}
</script>

<style lang="scss" scoped>
@use "../../../../scss/v2/base/variables";
@use "sass:math";

// ベースとなるデバイス幅
$grid-device-width: 375px;
// 余白
$grid-base: percentage(math.div(16px, $grid-device-width)); // 16px
$grid-consistent: $grid-base * 0.5; // 8px

.c-jhs-free-lp {
    margin-bottom: -$grid-consistent;
    margin-top: -$grid-consistent;

    &-top-img {
        width: 100%;
        aspect-ratio: 125 / 97;
    }

    &-section {
        margin-right: -$grid-consistent;
        margin-left: -$grid-consistent;

        &-feature {
            &-title {
                width: 90%;
                aspect-ratio: 311/76;
                margin-left: 5%;
            }

            &-img01 {
                width: 100%;
                aspect-ratio: 343 / 311;
            }
        }

        &-content {
            position: relative;

            .c-jhs-free-lp-confirm-qualification-help {
                position: absolute;
                padding-bottom: 5%;
                bottom: 0;
                left: 0;
                width: 100%;
            }
        }

        &-frame {
            padding: $grid-base*2 0;
            background: variables.$color-white;
            border-radius: 16px;
            h3 {
                margin: 0;
            }
            &--sm {
                padding: $grid-base 0;
            }
        }
    }

    &-requires-item {
        padding: 0 $grid-consistent;
    }

    &-faq {
        background: rgba(variables.$color-white, variables.$opacity-50);
        border-radius: 16px;
        padding: $grid-base 0;

        &-list {
            padding: $grid-base;
        }

        &-item {
            margin-bottom: $grid-base;
            background: variables.$color-white;
            border-radius: 16px;

            &:last-child {
                padding: 12px 0;
                margin-bottom: $grid-consistent;
            }
        }

        &-accordion {
            // アコーディオンopen時
            &[open] {
                > .c-jhs-free-lp-faq-title {
                    &:after {
                        transform: rotateX(0deg);
                    }
                }
            }
        }

        &-title {
            position: relative;
            background: variables.$color-white;
            border-radius: 16px;
            box-shadow: 0 2px 8px 0 rgba(variables.$color-jhs-free-shadow-red, variables.$opacity-50);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: $grid-base;
            -webkit-perspective: 500px;
            perspective: 500px;
            list-style: none;

            &::-webkit-details-marker {
                display: none;
            }

            &:after {
                display: block;
                content: "";
                width: 16px;
                height: 16px;
                position: absolute;
                background: v-bind("buildStyleImgUrl('icon_arrow.png')");
                transform: rotateX(180deg);
                background-size: contain;
                right: 16px;
                top: 50%;
                margin-top: -8px;
            }
        }

        &-content {
            padding: $grid-base $grid-consistent;

            .m-list-text-item {
                font-size: 1.2rem;
                margin-bottom: $grid-consistent * 0.5;
            }
        }
    }

    &-animation {
        opacity: variables.$opacity-0;
        transform: translateY(40px);
        transition: opacity 0.2s, transform 0.8s;

        &.show-section {
            opacity: variables.$opacity-100;
            transform: translateY(0);
        }

        &_button {
            .button {
                opacity: variables.$opacity-0;
                transform: translateY(40px);
                transition: opacity 0s, transform 0.8s;
            }

            &.show-button {
                .button {
                    width: 100%;
                    opacity: variables.$opacity-100;
                    transform: translateY(0);
                    position: fixed;
                    bottom: 0;
                    left: 0;
                }
            }
        }
    }

    .is-none {
        display: none;
    }

    .is-background-blue {
        background: variables.$color-jhs-free-bg-blue;
    }

    .is-background-pink {
        background: variables.$color-jhs-free-bg-pink-2024;
    }

    .c-dotted-line-position {
        margin: 15px 0 29px;
    }

    .c-img-menu03 {
        margin-top: 28px;
    }
}
</style>
